import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberAIToolsPage from "@/pages/member/MemberAIToolsPage";

export const Route = createFileRoute("/member/ai-tools")({
  head: () => pageHead("Member · Ai Tools", "AKIVA member · ai tools portal.", "/member/ai-tools", true),
  component: MemberAIToolsPage,
});
